module.exports = __webpack_public_path__ + "../resources/images/contact-card-icon-favorite-1906cbef284a90cd5d4e7eda55be76f5.png";